module.exports = __webpack_public_path__ + "files/7c671c8d9296b038d47d861e44a190ac.png";